import { createContext, useContext } from 'react';

import { storesMapContextInitialValue } from './stores.constants';
import { StoresContextType } from './stores.types';

export const StoresContext = createContext<StoresContextType>(
  storesMapContextInitialValue
);

export const useStoresContext = () => {
  const context = useContext(StoresContext);

  if (!context) {
    throw new Error(
      'useStoresContext must be used within a StoresContextProvider'
    );
  }

  return context;
};
